import React from "react";
import { useDispatch, useSelector } from "react-redux";
import cancelImg from "../assets/images/cancel.svg";
import { authorChanged, categoryChanged } from "../redux/filters/actions";
import BlogList from "./BlogList";

const Blogs = () => {
  const dispatch = useDispatch();
  const filterState = useSelector((state) => state.filters);

  const handleCategorySelect = (category) => {
    dispatch(categoryChanged(category));
  };

  const handleAuthorSelect = (author) => {
    dispatch(authorChanged(author));
  };

  return (
    <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
      <div className="absolute inset-0">
        <div className="bg-white h-1/3 sm:h-2/3"></div>
      </div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            ALL BLOGS ARE HERE
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
            libero labore natus atque, ducimus sed.
          </p>
        </div>
        {filterState?.category?.length > 0 && (
          <div className="flex items-center gap-2">
            <h4 className="font-medium mb-1">Category: </h4>
            {filterState.category.map((data, i) => (
              <p
                key={i}
                className="text-sm font-medium text-indigo-600"
                onClick={() => handleCategorySelect(data)}
              >
                <span className="inline-flex items-center pl-3 pr-2 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 cursor-pointer">
                  {data}
                  <img
                    className="w-3 ml-1 pt-[1px]"
                    src={cancelImg}
                    alt="cancel icon"
                  />
                </span>
              </p>
            ))}
          </div>
        )}
        {filterState?.author?.length > 0 && (
          <div className="flex items-center gap-2 mt-1">
            <h4 className="font-medium">Author: </h4>
            <h4
              className="font-semibold cursor-pointer bg-indigo-100 px-[9px] py-[1px] rounded-full text-indigo-600 flex items-center"
              onClick={() => handleAuthorSelect(filterState?.author)}
            >
              {filterState?.author}
              <img
                className="w-3 ml-1"
                src={cancelImg}
                alt="cancel icon"
              />
            </h4>
          </div>
        )}
        <BlogList />
      </div>
    </section>
  );
};

export default Blogs;
